/**
 * '+1 day' when a run's revised loading time falls on another day than its
 * loading date (a delay past midnight). The API sends `revisedAt` as ISO 8601
 * with the resort offset, so its first ten characters are the resort date.
 * '' when there is no revised time or it is on the loading date.
 */
export function revisedDayNote(revisedAt, loadingDate) {
  if (!revisedAt || !loadingDate) return ''
  const revised = Date.parse(`${String(revisedAt).slice(0, 10)}T12:00:00Z`)
  const loading = Date.parse(`${String(loadingDate).slice(0, 10)}T12:00:00Z`)
  if (!Number.isFinite(revised) || !Number.isFinite(loading)) return ''
  const days = Math.round((revised - loading) / 86400000)
  if (!days) return ''
  return `${days > 0 ? '+' : '-'}${Math.abs(days)} day`
}
